import marketCalendar from "./marketcalendar";
import watchlistCalendar from "./watchlist";
import marketCalendarCorporate from "./market-calendar-corporate";
import economy from "./Economy"

export default {
  marketCalendar,
  watchlistCalendar,
  marketCalendarCorporate,
  economy
}
